import { Box, Card, Grid, Stack, Typography } from "@compass/core";
import { ReportOutputFormats, Select } from "components";
import "moment-timezone";

import { ReportSelection, ReportType } from "./StudentReportPage";

export const StudentReportType = (props: {
  reportTypes: ReportSelection[];
  selectedReportType: ReportType | undefined;
  setSelectedReportType: (value: React.SetStateAction<ReportType | undefined>) => void;
}) => {
  return (
    <Card>
      <Grid container spacing="sm">
        <Grid item xs={4}>
          <Select
            label="Report Type"
            required
            value={props.reportTypes.find((x) => x.name === props.selectedReportType)}
            options={props.reportTypes}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) => props.setSelectedReportType(value?.name)}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                <Stack
                  position="relative"
                  direction="row"
                  spacing="md"
                  alignItems={"center"}
                  justifyContent="space-between"
                  width="100%"
                >
                  <Typography>{option.name}</Typography>
                  <ReportOutputFormats formats={option.generateTypes} />
                </Stack>
              </Box>
            )}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
